// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__AxQDz","img":"Register_img__rx4sK"};